import React from "react";
import styles from "./SignInButton.scss";

function UserIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.icon}
    >
      <g clipPath="url(#userIconClip)">
        <path d="M6.00139 0C4.2871 0 2.88574 1.40135 2.88574 3.11565C2.88574 4.82995 4.2871 6.2313 6.00139 6.2313C7.71569 6.2313 9.11704 4.82995 9.11704 3.11565C9.11704 1.40135 7.71569 0 6.00139 0Z" />
        <path d="M11.3474 8.72102C11.2658 8.51693 11.1569 8.32646 11.0345 8.14958C10.4086 7.2244 9.44266 6.61216 8.35423 6.4625C8.21818 6.44891 8.06852 6.47609 7.95967 6.55773C7.38824 6.9795 6.70798 7.19719 6.00048 7.19719C5.29298 7.19719 4.61272 6.9795 4.04128 6.55773C3.93243 6.47609 3.78277 6.43529 3.64673 6.4625C2.55829 6.61216 1.57871 7.2244 0.966465 8.14958C0.844018 8.32646 0.735163 8.53055 0.653549 8.72102C0.612742 8.80266 0.626335 8.89789 0.667143 8.97953C0.775997 9.17 0.912038 9.3605 1.03449 9.52375C1.22496 9.78227 1.42904 10.0135 1.66035 10.2312C1.85081 10.4217 2.0685 10.5986 2.28621 10.7754C3.36102 11.5782 4.65355 11.9999 5.98688 11.9999C7.32022 11.9999 8.61274 11.5782 9.68756 10.7754C9.90524 10.6122 10.1229 10.4217 10.3134 10.2312C10.5311 10.0135 10.7488 9.78224 10.9393 9.52375C11.0753 9.34688 11.1978 9.17 11.3066 8.97953C11.3746 8.89789 11.3882 8.80263 11.3474 8.72102Z" />
      </g>
      <defs>
        <clipPath id="userIconClip">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UserIcon;



// WEBPACK FOOTER //
// ./src/containers/UserMenu/SignInButton/UserIcon.tsx